import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation, Trans } from 'react-i18next';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';

//components 
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Badge from "beaktShared/components/Badge/Badge.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

//services
import { MaskDate, validateDate, convertDate, formateDate, transformValueFloattoFormated } from "beaktShared/helpers/masks";
import { UsePostApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(styles);


export default function VisualizarTodosContratosVencidos({ closemodal, showmodal }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);
  const [notification, setNotification] = React.useState({
    show: false,
    color: 'info',
    message: ''
  });
  const showNotification = (message, color) => {
    setNotification({
      show: true,
      color: color,
      message: message
    });
    setTimeout(function () {
      setNotification({ show: false });
    }, 6000);
  };

  useEffect(() => {
    loadVisualizarTodosContratosVencidos();
  }, [showmodal])


  const [dadosContratosVencidos, setdadosContratosVencidos] = React.useState([]);
  const [loadingContratosVencidos, setloadingContratosVencidos] = React.useState([]);
  const [dataCSV, setdataCSV] = React.useState([]);

  const loadVisualizarTodosContratosVencidos = () => {
    setloadingContratosVencidos(true);
    const endPoint = "dashboard/contratosvencidos/" + session.franquiaId + "/" + 0;
    UsePostApi(endPoint).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger')
        setloadingContratosVencidos(false);
        return false;
      }

      setdadosContratosVencidos(result.data);
      setloadingContratosVencidos(false);

      //dados para CSV
      let dtCsv = [];
      result.data.map(item => {
        var obj = {
          estabelecimento: item.estabelecimento,
          dataValidade: formateDate(item.dataValidade),
          diasParaVencimento: item.diasVencidos
        }
        dtCsv.push(obj);
      })

      setdataCSV(dtCsv);

      return true;
    });
  }

  const columnsProps = [
    {
      Header: t('label.establishment'),
      accessor: "estabelecimento",
    },
    {
      Header: t('dashboard.contract_validity'),
      accessor: "dataValidade",
      Cell: (props) => <div> {formateDate(props.value)} </div>

    },
    {
      Header: t('dashboard.days_overdue'),
      accessor: "diasVencidos",
      Cell: (props) => <div> <Badge color="danger">{(props.value)}</Badge></div>
    },
  ]
  let columns = [...columnsProps];

  const handleCloseModalContratosVencidos = () => {
    closemodal(false);
  }

  // *******************************************************************************
  // ********************************** CABEÇALHO CSV **********************************
  // *******************************************************************************

  const columnsCSV = [
    { displayName: "Estabelecimento", id: "estabelecimento" },
    { displayName: "Validade Contrato", id: "dataValidade" },
    { displayName: "Dias p/ vencimento", id: "diasParaVencimento" }
  ];

  return (
    <div>

      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal + ' ' + classes.modalLarge
        }}
        fullWidth
        maxWidth="lg"
        open={showmodal}
        keepMounted
        onClose={() => handleCloseModalContratosVencidos()}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
          style={{ background: '#5c4477' }}
        >
          <h4 className={classes.modalTitle} style={{ color: 'white' }}>Todos Contratos Vencidos</h4>
        </DialogTitle>
        <DialogContent id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>

                {dataCSV.length > 0 &&

                  <div>
                    <div style={{ float: 'right' }}>
                      <CsvDownloader
                        filename="ContratosVencidos"
                        columns={columnsCSV}
                        datas={dataCSV}
                        separator={";"}>
                        <Button round color="default" size="sm" >CSV</Button>
                      </CsvDownloader>
                    </div><div style={{ clear: 'both' }}></div>
                  </div>
                }
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <ReactTable
                  loading={loadingContratosVencidos}
                  data={dadosContratosVencidos}
                  columns={columns}
                  filterable
                  // defaultFilterMethod={noCaseSensitive}
                  defaultPageSize={10}
                  minRows={5}
                  showPaginationBottom={true}
                  className="-striped -highlight"
                  previousText='Anterior'
                  nextText='Próximo'
                  loadingText='Carregando...'
                  noDataText='Nenhum registro encontrado!'
                  pageText='Página'
                  ofText='de'
                  rowsText='linhas'
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </DialogContent>
      </Dialog>

    </div>
  );
}
